import { FormatedType } from "./types";

export const sortSubjectsFunction = (a: FormatedType, b: FormatedType): number => {
  if (a.group === null || a.group === undefined) return 1;
  if (b.group === null || b.group === undefined) return -1;
  if (a.group !== b.group) return a.group.localeCompare(b.group);
  return a.position - b.position;
};
